// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__Jxz30"};